import { Controller } from '@hotwired/stimulus'

export default class ImageFallbackController extends Controller {
  static values = { src: String }

  connect () {
    if (this.element.complete && this.element.naturalWidth === 0) this.useFallback()
  }

  useFallback () {
    if (!this.hasSrcValue || this.element.src.endsWith(this.srcValue)) return

    this.element.src = this.srcValue
  }
}
